export const SET_COURSE_PORTFOLIO_DEFAULT = 'SET_COURSE_PORTFOLIO_DEFAULT';
